import { getImageProps } from 'next/image';

import getSrcUrl from '@/app/components/Image/utils/getSrcUrl';

const getFinishSwatchImgixSrc = (src: string): string => {
  return getImageProps({
    alt: '',
    height: 40,
    priority: true,
    src: getSrcUrl(src),
    width: 40,
  }).props.src;
};

export default getFinishSwatchImgixSrc;
